export enum PopularSectionTabsEnum {
  All = 'popular',
  BigWin = 'bigwin',
  LuckyGame = 'lucky',
}

export enum TopWinnerSectionTabsEnum {
  Weekly = 'weekly',
  Monthly = 'monthly',
  Daily = 'daily',
}
